module.exports = "https://static.wmbcdn.com/uniweb/images/2b674fad2d291efa681cb164611c9f73.svg";